import De, { memo as st, useState as w, useReducer as at, useCallback as V, useEffect as F, useContext as k, useMemo as te, createContext as rt } from "react";
import { useNavigate as $, useLocation as it, Routes as $e, Route as N } from "react-router-dom";
import { FormElement as Re, ConfirmationDialog as je, SpinnerWidgetContainer as Ue, FavoritesHeader as ot, HomePageWidgetList as ct, HomePageWidgetListItem as ge, ModuleDescriptionCard as lt, TabWithCounter as ee, ICON_COLUMN as ut, NAME_COLUMN as dt, DATE_COLUMN as mt, UPDATED_COLUMN as ft, AUTHOR_COLUMN as gt, EntityTypeCell as Se, NameCell as he, PageList as pt, AuthorCell as St, DateCell as Ge, BaseContentWrapper as ht, BaseInfoWrapper as bt, ListHeaderPrimary as Ct, TabsNavigationNew as yt, BaseEntityContent as Et } from "@prometheus/features";
import { useNotifications as ne, Grid as _, Block as xt, Input as It, Button as M, Spinner as be, Icon as J, EmptyTableStub as _e, Tooltip as Tt, Box as Rt, useTheme as Ye, StatusTag as Be, NewTable as qe } from "@prometheus/components";
import { Status as b } from "@prometheus/types";
import { api as y, getSortDirection as jt, getReducerWithProduce as _t, getUUID as ve, createSortingMethodListConfig as vt, createHeadersFromMetadataAttributes as At, createFiltersPanelListConfig as Nt, createCrudMethodsListConfig as Ot, getInvitationColorModel as He, setErrorHandlingNotifications as wt } from "@prometheus/utils";
import { EntityTypes as h, InvitationStatus as We, EntityTypeLabel as Ft, ENTITY_TYPES as O, EntityType as Pt, invitationTypes as Ke, TypesOfContainer as Y } from "@prometheus/enums";
import { ModalContext as zt, DialogContext as Lt, useRequest as Mt } from "@prometheus/hooks";
import { setBreadcrumbs as Ve } from "@prometheus/redux";
import { useDispatch as Je } from "react-redux";
var pe = { exports: {} }, W = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ae;
function kt() {
  if (Ae) return W;
  Ae = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(a, i, o) {
    var l = null;
    if (o !== void 0 && (l = "" + o), i.key !== void 0 && (l = "" + i.key), "key" in i) {
      o = {};
      for (var f in i)
        f !== "key" && (o[f] = i[f]);
    } else o = i;
    return i = o.ref, {
      $$typeof: e,
      type: a,
      key: l,
      ref: i !== void 0 ? i : null,
      props: o
    };
  }
  return W.Fragment = t, W.jsx = n, W.jsxs = n, W;
}
var K = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ne;
function Dt() {
  return Ne || (Ne = 1, process.env.NODE_ENV !== "production" && function() {
    function e(r) {
      if (r == null) return null;
      if (typeof r == "function")
        return r.$$typeof === le ? null : r.displayName || r.name || null;
      if (typeof r == "string") return r;
      switch (r) {
        case I:
          return "Fragment";
        case v:
          return "Profiler";
        case x:
          return "StrictMode";
        case ie:
          return "Suspense";
        case oe:
          return "SuspenseList";
        case ce:
          return "Activity";
      }
      if (typeof r == "object")
        switch (typeof r.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), r.$$typeof) {
          case E:
            return "Portal";
          case ae:
            return (r.displayName || "Context") + ".Provider";
          case L:
            return (r._context.displayName || "Context") + ".Consumer";
          case re:
            var m = r.render;
            return r = r.displayName, r || (r = m.displayName || m.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
          case H:
            return m = r.displayName || null, m !== null ? m : e(r.type) || "Memo";
          case X:
            m = r._payload, r = r._init;
            try {
              return e(r(m));
            } catch {
            }
        }
      return null;
    }
    function t(r) {
      return "" + r;
    }
    function n(r) {
      try {
        t(r);
        var m = !1;
      } catch {
        m = !0;
      }
      if (m) {
        m = console;
        var C = m.error, R = typeof Symbol == "function" && Symbol.toStringTag && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return C.call(
          m,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          R
        ), t(r);
      }
    }
    function a(r) {
      if (r === I) return "<>";
      if (typeof r == "object" && r !== null && r.$$typeof === X)
        return "<...>";
      try {
        var m = e(r);
        return m ? "<" + m + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var r = U.A;
      return r === null ? null : r.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function l(r) {
      if (Z.call(r, "key")) {
        var m = Object.getOwnPropertyDescriptor(r, "key").get;
        if (m && m.isReactWarning) return !1;
      }
      return r.key !== void 0;
    }
    function f(r, m) {
      function C() {
        P || (P = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          m
        ));
      }
      C.isReactWarning = !0, Object.defineProperty(r, "key", {
        get: C,
        configurable: !0
      });
    }
    function d() {
      var r = e(this.type);
      return Q[r] || (Q[r] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), r = this.props.ref, r !== void 0 ? r : null;
    }
    function u(r, m, C, R, z, A, de, me) {
      return C = A.ref, r = {
        $$typeof: c,
        type: r,
        key: m,
        props: A,
        _owner: z
      }, (C !== void 0 ? C : null) !== null ? Object.defineProperty(r, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(r, "ref", { enumerable: !1, value: null }), r._store = {}, Object.defineProperty(r._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(r, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(r, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: de
      }), Object.defineProperty(r, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: me
      }), Object.freeze && (Object.freeze(r.props), Object.freeze(r)), r;
    }
    function p(r, m, C, R, z, A, de, me) {
      var j = m.children;
      if (j !== void 0)
        if (R)
          if (ue(j)) {
            for (R = 0; R < j.length; R++)
              g(j[R]);
            Object.freeze && Object.freeze(j);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else g(j);
      if (Z.call(m, "key")) {
        j = e(r);
        var G = Object.keys(m).filter(function(nt) {
          return nt !== "key";
        });
        R = 0 < G.length ? "{key: someKey, " + G.join(": ..., ") + ": ...}" : "{key: someKey}", Te[j + R] || (G = 0 < G.length ? "{" + G.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          R,
          j,
          G,
          j
        ), Te[j + R] = !0);
      }
      if (j = null, C !== void 0 && (n(C), j = "" + C), l(m) && (n(m.key), j = "" + m.key), "key" in m) {
        C = {};
        for (var fe in m)
          fe !== "key" && (C[fe] = m[fe]);
      } else C = m;
      return j && f(
        C,
        typeof r == "function" ? r.displayName || r.name || "Unknown" : r
      ), u(
        r,
        j,
        A,
        z,
        i(),
        C,
        de,
        me
      );
    }
    function g(r) {
      typeof r == "object" && r !== null && r.$$typeof === c && r._store && (r._store.validated = 1);
    }
    var S = De, c = Symbol.for("react.transitional.element"), E = Symbol.for("react.portal"), I = Symbol.for("react.fragment"), x = Symbol.for("react.strict_mode"), v = Symbol.for("react.profiler"), L = Symbol.for("react.consumer"), ae = Symbol.for("react.context"), re = Symbol.for("react.forward_ref"), ie = Symbol.for("react.suspense"), oe = Symbol.for("react.suspense_list"), H = Symbol.for("react.memo"), X = Symbol.for("react.lazy"), ce = Symbol.for("react.activity"), le = Symbol.for("react.client.reference"), U = S.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Z = Object.prototype.hasOwnProperty, ue = Array.isArray, T = console.createTask ? console.createTask : function() {
      return null;
    };
    S = {
      react_stack_bottom_frame: function(r) {
        return r();
      }
    };
    var P, Q = {}, xe = S.react_stack_bottom_frame.bind(
      S,
      o
    )(), Ie = T(a(o)), Te = {};
    K.Fragment = I, K.jsx = function(r, m, C, R, z) {
      var A = 1e4 > U.recentlyCreatedOwnerStacks++;
      return p(
        r,
        m,
        C,
        !1,
        R,
        z,
        A ? Error("react-stack-top-frame") : xe,
        A ? T(a(r)) : Ie
      );
    }, K.jsxs = function(r, m, C, R, z) {
      var A = 1e4 > U.recentlyCreatedOwnerStacks++;
      return p(
        r,
        m,
        C,
        !0,
        R,
        z,
        A ? Error("react-stack-top-frame") : xe,
        A ? T(a(r)) : Ie
      );
    };
  }()), K;
}
process.env.NODE_ENV === "production" ? pe.exports = kt() : pe.exports = Dt();
var s = pe.exports;
const $t = st((e) => {
  const { onClose: t, item: n, inviteMethod: a, typeEntity: i, id: o, name: l, type: f } = e, [d, u] = w(b.INITIAL), [p, g] = w(), { enqueueSnackbar: S } = ne(), c = async () => {
    u(b.IN_PROGRESS);
    try {
      await a(p, () => {
        u(b.SUCCESS);
      });
    } catch {
      u(b.ERROR);
    }
  };
  return /* @__PURE__ */ s.jsx(_, { container: !0, children: /* @__PURE__ */ s.jsx(xt, { children: /* @__PURE__ */ s.jsxs(_, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ s.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsxs(Re, { children: [
      f === "INCOMING" ? "Reject" : "Cancel",
      " publishing",
      " ",
      /* @__PURE__ */ s.jsx("b", { children: l }),
      " for reason:"
    ] }) }),
    /* @__PURE__ */ s.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(Re, { name: "message", textLabel: "Response Message", children: /* @__PURE__ */ s.jsx(
      It,
      {
        type: "text",
        value: p || "",
        minRows: 2,
        maxRows: 4,
        multiline: !0,
        size: "medium",
        onChange: (E) => g(E.target.value),
        fullWidth: !0,
        name: "message"
      }
    ) }) }),
    /* @__PURE__ */ s.jsxs(_, { item: !0, xs: 12, textAlign: "right", children: [
      /* @__PURE__ */ s.jsx(
        M,
        {
          variant: "outlined",
          onClick: t,
          disabled: d === b.IN_PROGRESS,
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        M,
        {
          onClick: c,
          variant: "contained",
          color: "error",
          name: "save",
          disabled: d === b.IN_PROGRESS,
          sx: { ml: 1 },
          startIcon: d === b.IN_PROGRESS ? /* @__PURE__ */ s.jsx(be, { size: 16 }) : /* @__PURE__ */ s.jsx(J, { iconName: "deactivate" }),
          children: f === "INCOMING" ? "Reject publishing" : "Cancel"
        }
      )
    ] })
  ] }) }) });
});
var B = /* @__PURE__ */ ((e) => (e.LIBRARY = "library", e.INCOMING = "incoming", e.OUTGOING = "outgoing", e))(B || {});
const Xe = (e, t) => {
  const { pageNumber: n, pageSize: a, sortBy: i, query: o } = t, l = jt(i);
  return `${e}?size=${a || ""}&page=${n || 0}&sort=${l}&${o || ""}`;
}, Ut = async (e, t) => {
  var a;
  let n = null;
  for (const i of e)
    try {
      return await y.get(Xe(i, t));
    } catch (o) {
      n = o;
      const l = (a = o == null ? void 0 : o.response) == null ? void 0 : a.status;
      if (![400, 403, 404, 405].includes(l))
        throw o;
    }
  throw n;
}, Ze = (e) => y.get(Xe("/library/list", e)), Gt = () => y.get("/library/sorts"), Yt = (e) => {
  const t = `/library/filter?${e}`;
  return y.get(t);
}, Bt = () => y.get("/library/cohort/invites/incoming"), qt = () => y.get("/library/cohort/invites/outgoing"), Ht = (e) => y.post(`/library/cohort/invites/${e}/accept`), Wt = (e, t) => y.post(`/library/cohort/invites/${e}/dismiss`, t), Kt = () => y.get("/library/custom-code/invites/incoming"), Vt = () => y.get("/library/custom-code/invites/outgoing"), Jt = (e) => y.post(`/library/custom-code/invites/${e}/accept`), Xt = (e, t) => y.post(`/library/custom-code/invites/${e}/dismiss`, t), Zt = () => y.get("/library/concept-set/invites/incoming"), Qt = () => y.get("/library/concept-set/invites/outgoing"), en = (e) => y.post(`/library/concept-set/invites/${e}/accept`), tn = (e, t) => y.post(`/library/concept-set/invites/${e}/dismiss`, t), Ce = () => y.get("/library/summary"), Oe = async () => {
  var t;
  const e = await Ut(["/draft-features/list"], {
    pageNumber: 0,
    pageSize: 1,
    sortBy: { id: "modified.timestamp", desc: !0 },
    query: ""
  });
  return Number(
    (e == null ? void 0 : e.totalElements) ?? (e == null ? void 0 : e.numberOfElements) ?? ((t = e == null ? void 0 : e.content) == null ? void 0 : t.length) ?? 0
  );
}, se = "/library/feature-analyses/invites", nn = () => y.get(`${se}/incoming`), sn = () => y.get(`${se}/outgoing`), an = (e) => y.post(`${se}/${e}/accept`), rn = (e, t) => y.post(`${se}/${e}/dismiss`, t);
var D = /* @__PURE__ */ ((e) => (e.ACCEPT_SUCCESS = "ACCEPT_SUCCESS", e.DISMISS_SUCCESS = "DISMISS_SUCCESS", e))(D || {});
const on = {
  list: [],
  status: b.INITIAL,
  forceReload: null,
  error: null,
  notifyMessage: null
}, we = (e) => Array.isArray(e) ? e : (e == null ? void 0 : e.data) ?? [], cn = (e, t) => _t(e, (n) => {
  switch (t.type) {
    case "GET_LIST":
      n.status = b.IN_PROGRESS, n.list = [], n.error = null;
      break;
    case "ACCEPT_DONE":
      n.status = "ACCEPT_SUCCESS", n.forceReload = ve(), n.notifyMessage = `Request to publish ${t.payload} successfully approved`, n.error = null;
      break;
    case "DISMISS_DONE":
      n.status = "DISMISS_SUCCESS", n.forceReload = ve(), n.notifyMessage = `Request to publish ${t.payload} declined`, n.error = null;
      break;
    case "GET_LIST_DONE":
      n.list = t.payload, n.status = b.SUCCESS;
      break;
    case "GET_LIST_FAILED":
    case "ACCEPT_FAILED":
    case "DISMISS_FAILED":
      n.list = [], n.status = b.ERROR, n.error = t.payload;
      break;
  }
}), ye = (e, t = !1) => {
  const [n, a] = at(cn, on), i = V(async () => {
    a({
      type: "GET_LIST"
      /* GET_LIST */
    });
    try {
      const d = await Bt(), u = await Zt(), p = await Kt(), g = we(
        await nn().catch(() => [])
      ), S = [
        ...d.map((c) => ({ ...c, typeEntity: h.COHORT })),
        ...u.map((c) => ({ ...c, typeEntity: h.CONCEPT_SET })),
        ...p.map((c) => ({
          ...c,
          typeEntity: h.CUSTOM_CODE,
          subject: { ...c.subject, name: c == null ? void 0 : c.subject.title }
        })),
        ...g.map((c) => {
          var E, I;
          return {
            ...c,
            typeEntity: h.FEATURE_ANALYSIS,
            subject: {
              ...c.subject,
              name: ((E = c == null ? void 0 : c.subject) == null ? void 0 : E.name) || ((I = c == null ? void 0 : c.subject) == null ? void 0 : I.title)
            }
          };
        })
      ];
      a({
        type: "GET_LIST_DONE",
        payload: S
      });
    } catch (d) {
      a({
        type: "GET_LIST_FAILED",
        payload: d
      });
    }
  }, []), o = V(async () => {
    a({
      type: "GET_LIST"
      /* GET_LIST */
    });
    try {
      const d = await qt(), u = await Qt(), p = await Vt(), g = we(
        await sn().catch(() => [])
      ), S = [
        ...d.map((c) => ({ ...c, typeEntity: h.COHORT })),
        ...u.map((c) => ({ ...c, typeEntity: h.CONCEPT_SET })),
        ...p.map((c) => ({
          ...c,
          typeEntity: h.CUSTOM_CODE,
          subject: { ...c.subject, name: c == null ? void 0 : c.subject.title }
        })),
        ...g.map((c) => {
          var E, I;
          return {
            ...c,
            typeEntity: h.FEATURE_ANALYSIS,
            subject: {
              ...c.subject,
              name: ((E = c == null ? void 0 : c.subject) == null ? void 0 : E.name) || ((I = c == null ? void 0 : c.subject) == null ? void 0 : I.title)
            }
          };
        })
      ];
      a({
        type: "GET_LIST_DONE",
        payload: S
      });
    } catch (d) {
      a({
        type: "GET_LIST_FAILED",
        payload: d
      });
    }
  }, []), l = V(
    async (d, u, p) => {
      a({
        type: "ACCEPT"
        /* ACCEPT */
      });
      try {
        switch (d) {
          case h.COHORT:
            await Ht(u);
            break;
          case h.CONCEPT_SET:
            await en(u);
            break;
          case h.CUSTOM_CODE:
            await Jt(u);
            break;
          case h.FEATURE_ANALYSIS:
            await an(u);
            break;
        }
        a({
          type: "ACCEPT_DONE",
          payload: p
        });
      } catch (g) {
        a({
          type: "ACCEPT_FAILED",
          payload: g
        });
      }
    },
    []
  ), f = V(
    async (d, u, p, g) => {
      a({
        type: "DISMISS"
        /* DISMISS */
      });
      try {
        switch (d) {
          case h.COHORT:
            await Wt(u, { note: p || "" });
            break;
          case h.CONCEPT_SET:
            await tn(u, { note: p || "" });
            break;
          case h.CUSTOM_CODE:
            await Xt(u, { note: p || "" });
            break;
          case h.FEATURE_ANALYSIS:
            await rn(u, { note: p || "" });
            break;
        }
        a({
          type: "DISMISS_DONE",
          payload: g
        });
      } catch (S) {
        a({
          type: "DISMISS_FAILED",
          payload: S
        });
      }
    },
    []
  );
  return F(() => {
    if (!t)
      switch (e) {
        case B.INCOMING:
          i();
          break;
        case B.OUTGOING:
          o();
      }
  }, [e, n.forceReload]), {
    ...n,
    getIncomes: i,
    acceptInvitation: l,
    dismissInvitation: f
  };
}, Ee = (e) => {
  const {
    id: t,
    type: n,
    name: a,
    typeEntity: i,
    accept: o,
    dismiss: l,
    textAccept: f = "Accept",
    textDismiss: d,
    isRedirect: u = !1,
    requestStatus: p
  } = e, g = d || (n === "OUTGOING" ? "Cancel" : "Reject"), S = !p || p === We.PENDING, { openModal: c, closeModal: E } = k(zt), [I, x] = w(!1), { showDialog: v, hideDialog: L } = k(Lt), ae = $(), { enqueueSnackbar: re } = ne(), { acceptInvitation: ie, dismissInvitation: oe, status: H, notifyMessage: X } = ye(B.LIBRARY, !0), ce = () => {
    v(je, {
      onSubmit: async () => {
        x(!0), o ? await o(i, t, a) : await Z(), x(!1);
      },
      onClose: L,
      text: `Please confirm approval to publish ${Ft[i]} ${a} to the library`,
      confirmButtonText: "Approve",
      variant: "success"
    });
  }, le = (T, P) => {
    v(je, {
      onSubmit: async () => {
        x(!0), l ? await l(i, t, T, a) : await ue(T), x(!1), E();
      },
      onDecline: () => {
        P == null || P();
      },
      onClose: L,
      text: `Please confirm ${g.toLowerCase()} to publish ${Pt[i]} ${a} in the library`,
      confirmButtonText: "Confirm"
    });
  }, U = () => {
    var T;
    c(
      () => /* @__PURE__ */ s.jsx(
        $t,
        {
          name: a,
          inviteMethod: (P, Q) => {
            le(P, Q);
          },
          onClose: E,
          typeEntity: i,
          type: n,
          id: t
        }
      ),
      `${g} publishing ${(T = O[i]) == null ? void 0 : T.name}`,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: E
      }
    );
  }, Z = async () => {
    await ie(i, t, a);
  }, ue = async (T) => {
    await oe(i, t, T, a);
  };
  return F(() => {
    (H === D.ACCEPT_SUCCESS || H === D.DISMISS_SUCCESS) && (re({
      message: X,
      variant: "success"
    }), u && ae("/library"));
  }, [H]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    n === "INCOMING" && S && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        M,
        {
          size: "small",
          color: "success",
          variant: "contained",
          disabled: I,
          startIcon: /* @__PURE__ */ s.jsx(J, { iconName: "submit" }),
          onClick: (T) => {
            T.stopPropagation(), ce();
          },
          children: f
        }
      ),
      /* @__PURE__ */ s.jsx(
        M,
        {
          sx: { ml: 1 },
          size: "small",
          variant: "contained",
          color: "error",
          disabled: I,
          startIcon: /* @__PURE__ */ s.jsx(J, { iconName: "deactivate" }),
          onClick: (T) => {
            T.stopPropagation(), U();
          },
          children: g
        }
      )
    ] }),
    n === "OUTGOING" && S && /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx(
      M,
      {
        sx: { ml: 1 },
        size: u ? "medium" : "small",
        variant: "contained",
        color: "error",
        disabled: I,
        startIcon: /* @__PURE__ */ s.jsx(J, { iconName: "deactivate" }),
        onClick: (T) => {
          T.stopPropagation(), U();
        },
        children: g
      }
    ) })
  ] });
}, ln = {
  title: "Artifacts Library",
  url: "/library",
  description: "Artifacts Library is a governed collection of standardized artifacts, including concept sets and cohorts that can be imported and used as templates in studies. Re-use existing artifacts or publish new artifacts into the library to be re-used by others.",
  titleButton: "Go to library"
}, un = (e) => {
  const t = V((d) => Ze({
    pageNumber: 0,
    pageSize: 10,
    sortBy: { id: "published", desc: !0 }
  }), []), n = $(), { status: a, state: i } = Mt(t), [o, l] = w(!1), f = () => {
    l(!o);
  };
  return a === b.INITIAL || a === b.IN_PROGRESS ? /* @__PURE__ */ s.jsx(Ue, { children: /* @__PURE__ */ s.jsx(be, { size: 32 }) }) : /* @__PURE__ */ s.jsxs(_, { container: !0, children: [
    /* @__PURE__ */ s.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(ot, { children: "Recent Artifacts" }) }),
    /* @__PURE__ */ s.jsxs(ct, { children: [
      a === b.SUCCESS && (i != null && i.content.length ? i.content.slice(0, Math.min(i.content.length, o ? 10 : 5)).map((d) => {
        var p, g, S;
        const u = d.type;
        return /* @__PURE__ */ s.jsx(
          ge,
          {
            onClick: () => {
              u === h.CONCEPT_SET && n(`/library/concept-sets/${d.id}`), u === h.COHORT && n(`/library/cohorts/${d.id}`), u === h.FEATURE_ANALYSIS && n(`/library/feature-analyses/${d.id}`), u === h.CUSTOM_CODE && n(`/library/custom-code/${d.id}`);
            },
            children: /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: "list-item-section nowrap",
                title: (p = O[u]) == null ? void 0 : p.name,
                children: [
                  /* @__PURE__ */ s.jsx(
                    J,
                    {
                      iconName: (g = O[u]) == null ? void 0 : g.iconName,
                      sx: {
                        color: (S = O[u]) == null ? void 0 : S.color
                      }
                    }
                  ),
                  /* @__PURE__ */ s.jsx("div", { className: "list-item-title", title: d.name, children: d.name })
                ]
              }
            )
          },
          d.id + "-recent-artifact"
        );
      }) : /* @__PURE__ */ s.jsx(ge, { light: !0, children: /* @__PURE__ */ s.jsx(_e, { noDataText: "No recent artifacts found", dark: !0 }) })),
      a === b.ERROR && /* @__PURE__ */ s.jsx(ge, { light: !0, children: /* @__PURE__ */ s.jsx(
        _e,
        {
          noDataText: "Failed to load recent artifacts",
          addButtonText: ""
        }
      ) })
    ] }),
    (i == null ? void 0 : i.content.length) > 5 && /* @__PURE__ */ s.jsx(_, { container: !0, justifyContent: "flex-end", mt: 2, children: /* @__PURE__ */ s.jsx(M, { onClick: f, size: "small", variant: "text", color: "info", children: o ? "Show less" : "Show more..." }) })
  ] });
}, dn = (e) => {
  const { name: t, config: n, ...a } = e, i = $(), { title: o, url: l, description: f, titleButton: d } = ln, {
    onAccept: u,
    onDismiss: p,
    typeEntity: g,
    nameEntity: S,
    type: c,
    id: E,
    isRedirect: I,
    requestStatus: x
  } = n;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    t === "answer-publish-widget" && /* @__PURE__ */ s.jsx(
      Ee,
      {
        ...a,
        type: c,
        typeEntity: g,
        name: S,
        id: E,
        accept: u,
        dismiss: p,
        isRedirect: I,
        requestStatus: x
      }
    ),
    t === "home-widget" && /* @__PURE__ */ s.jsx(
      lt,
      {
        title: o,
        onClick: () => i(l),
        description: f,
        iconName: "library",
        actions: /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx(
          M,
          {
            onClick: () => i(l),
            variant: "outlined",
            name: "save",
            children: d
          }
        ) }),
        children: /* @__PURE__ */ s.jsx(_, { item: !0, xs: 12, container: !0, pt: 2, children: /* @__PURE__ */ s.jsx(un, {}) })
      }
    )
  ] });
}, mn = {
  entityNavigationPanel: (e = !1, t, n, a = !1) => {
    const i = [
      {
        value: "",
        title: /* @__PURE__ */ s.jsx(
          ee,
          {
            title: "Artifacts library",
            count: (t == null ? void 0 : t.items) || 0,
            status: b.SUCCESS
          }
        ),
        end: !0
      }
    ];
    return e && i.push({
      value: "incoming",
      title: /* @__PURE__ */ s.jsx(
        ee,
        {
          title: "Publish requests",
          count: (t == null ? void 0 : t.incoming) || 0,
          status: b.SUCCESS
        }
      )
    }), (t == null ? void 0 : t.outgoing) > 0 && i.push({
      value: "outgoing",
      title: /* @__PURE__ */ s.jsx(
        ee,
        {
          title: "My submissions",
          count: (t == null ? void 0 : t.outgoing) || 0,
          status: b.SUCCESS
        }
      )
      // path: `outgoing`,
    }), a && i.push({
      value: "custom-features",
      title: /* @__PURE__ */ s.jsx(
        ee,
        {
          title: "Custom Features",
          count: n ?? (t == null ? void 0 : t.customFeatures) ?? (t == null ? void 0 : t.featureAnalyses) ?? (t == null ? void 0 : t.feature_analyses) ?? 0,
          status: b.SUCCESS
        }
      )
    }), i;
  }
}, fn = {
  rowId: "id",
  loadingMessage: "Loading...",
  addButtonTitle: null,
  tableTitle: "Artifacts library",
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createSortingMethod: (e) => vt(e, {
    getSorting: Gt
  }),
  createCrudMethod: (e, t) => Ot(
    e,
    t,
    Ze,
    (n) => Promise.resolve()
  ),
  createFiltersPanel: (e, t) => Nt(e, t, Yt),
  metadataFilter: `&filter.metadata.subject=${h.COHORT}&filter.metadata.subject=${h.CONCEPT_SET}`,
  extendedSearchEnabled: !0,
  extendedSearchOptions: ["basic", "meta"],
  getCols: ({ metaAttributes: e = [] }) => [
    ut({
      id: "typeIcon",
      cell: Se,
      accessorFn: (t) => O[t.type].iconName
    }),
    dt({
      size: 300,
      cell: (t) => {
        var n, a, i, o, l, f, d, u;
        return /* @__PURE__ */ s.jsx(
          Tt,
          {
            text: /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsx("strong", { children: (a = (n = t.row) == null ? void 0 : n.original) == null ? void 0 : a.name }),
              /* @__PURE__ */ s.jsx("br", {}),
              (o = (i = t.row) == null ? void 0 : i.original) != null && o.description ? (f = (l = t.row) == null ? void 0 : l.original) == null ? void 0 : f.description : ""
            ] }),
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ s.jsx(
              Rt,
              {
                sx: {
                  overflowX: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis"
                },
                children: /* @__PURE__ */ s.jsx(he, { value: (u = (d = t.row) == null ? void 0 : d.original) == null ? void 0 : u.name })
              }
            )
          }
        );
      }
    }),
    {
      header: "Type",
      accessorFn: (t) => {
        var n;
        return ((n = O[t.type]) == null ? void 0 : n.name) || "-";
      },
      id: "type",
      isCropped: !0,
      size: 140,
      minSize: 140,
      maxSize: 140,
      enableResizing: !1,
      meta: {
        align: "left",
        skeletonKind: "text"
      }
    },
    mt({
      header: "Published",
      id: "published",
      accessor: "published",
      accessorKey: "published"
    }),
    ft(),
    gt({
      id: "modified.user.name",
      accessor: "modified.user.name",
      size: 160
    }),
    ...At(e, !0)
  ]
}, gn = () => {
  const e = $(), t = k(
    q
  );
  return /* @__PURE__ */ s.jsx(
    pt,
    {
      isImport: !1,
      isEnableMetadata: !0,
      disableRowSelect: (n) => !!n.original.archived,
      onRowClick: (n) => {
        const a = n.original;
        a.type === h.CONCEPT_SET && e(`/library/concept-sets/${a.id}`), a.type === h.COHORT && e(`/library/cohorts/${a.id}`), a.type === h.FEATURE_ANALYSIS && e(`/library/feature-analyses/${a.id}`), a.type === h.CUSTOM_CODE && e(`/library/custom-code/${a.id}`);
      },
      moduleConfig: t,
      variant: "no-header",
      listConfig: fn
    }
  );
}, Fe = 7 * 24 * 60 * 60 * 1e3, pn = {
  "0_this_week": "This week",
  "1_last_week": "Last week",
  "2_more_than_two_weeks_ago": "More than 2 weeks ago"
}, Qe = (e) => {
  const t = new Date(e).getTime();
  if (!Number.isFinite(t))
    return "2_more_than_two_weeks_ago";
  const n = Date.now() - t;
  return n <= Fe ? "0_this_week" : n <= Fe * 2 ? "1_last_week" : "2_more_than_two_weeks_ago";
}, et = (e) => pn[e] || e || "-", Sn = {
  [h.CONCEPT_SET]: "concept-sets",
  [h.COHORT]: "cohorts",
  [h.FEATURE_ANALYSIS]: "custom-features/publish-requests",
  [h.CUSTOM_CODE]: "custom-code"
}, hn = (e) => {
  const t = (e == null ? void 0 : e.subject) || {}, n = t.id || t.uuid || t.referenceId || t.draftFeatureId || t.featureAnalysisId || (e == null ? void 0 : e.subjectId);
  return n ? String(n) : null;
}, tt = (e, t) => {
  const n = Sn[e == null ? void 0 : e.typeEntity], a = hn(e);
  if (!n || !a || !(e != null && e.id))
    return null;
  const i = new URLSearchParams({
    from: "LIBRARY",
    typePublish: t,
    id: String(e.id)
  });
  return e != null && e.status && i.set("status", String(e.status)), `/library/${n}/${encodeURIComponent(
    a
  )}?${i.toString()}`;
}, Pe = (e) => {
  var t;
  return ((t = Ke.find((n) => n.value === e)) == null ? void 0 : t.name) || e || "-";
}, bn = (e) => {
  var t;
  return ((t = O[e]) == null ? void 0 : t.name) || "-";
}, Cn = (e, t, n) => {
  var i, o;
  const a = (i = n == null ? void 0 : n[0]) == null ? void 0 : i.toLowerCase();
  return a ? [(o = e.original.subject) == null ? void 0 : o.name, e.original.message].some(
    (l) => String(l || "").toLowerCase().includes(a)
  ) : !0;
}, ze = {
  entityBreadcrumb: (e) => [
    {
      name: "Artifacts library",
      path: `${e}`
    },
    {
      name: "Publish Request",
      path: `${e}/incoming`
    }
  ],
  createCols: (e, t) => [
    {
      header: "Search",
      id: "search",
      accessorFn: (n) => {
        var a;
        return `${((a = n.subject) == null ? void 0 : a.name) || ""} ${n.message || ""}`;
      },
      filterFn: Cn,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      size: 0,
      minSize: 0,
      maxSize: 0,
      meta: {
        filterVariant: "value",
        invisible: !0
      }
    },
    {
      header: "",
      accessorFn: (n) => {
        var a;
        return (a = O[n.typeEntity]) == null ? void 0 : a.iconName;
      },
      id: "typeEntityIcon",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 48,
      minSize: 48,
      maxSize: 48,
      cell: (n) => /* @__PURE__ */ s.jsx(
        Se,
        {
          ...n,
          value: n.renderValue(),
          size: 26,
          cell: !0
        }
      ),
      meta: {
        columnType: "action",
        skeletonKind: "type-icon"
      }
    },
    {
      header: "Name",
      accessorKey: "subject.name",
      id: "subject.name",
      size: 420,
      minSize: 320,
      maxSize: 1200,
      enableColumnFilter: !1,
      cell: he
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      size: 120,
      minSize: 120,
      maxSize: 120,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      cell: ({ renderValue: n }) => {
        const a = Ye(), i = n();
        return /* @__PURE__ */ s.jsx(
          Be,
          {
            light: !0,
            text: Pe(i),
            color: He(i, a),
            align: "center"
          }
        );
      },
      meta: {
        filterOrder: 0,
        renderFilter: Pe
      }
    },
    {
      header: "Type",
      accessorFn: (n) => bn(n.typeEntity),
      id: "type",
      size: 140,
      minSize: 140,
      maxSize: 140,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 1
      }
    },
    {
      header: "Author",
      accessorKey: "created.user.name",
      id: "created.user.name",
      size: 190,
      minSize: 160,
      maxSize: 240,
      filterFn: "arrIncludesSomeEqual",
      cell: St,
      meta: {
        filterOrder: 2
      }
    },
    {
      header: "Created",
      accessorKey: "created.timestamp",
      id: "created.timestamp",
      size: 152,
      minSize: 152,
      maxSize: 152,
      enableColumnFilter: !1,
      enableResizing: !1,
      cell: Ge
    },
    {
      header: "Created",
      accessorFn: (n) => {
        var a;
        return Qe((a = n.created) == null ? void 0 : a.timestamp);
      },
      id: "created.filter",
      size: 0,
      minSize: 0,
      maxSize: 0,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 3,
        invisible: !0,
        renderFilter: et
      }
    },
    {
      header: "Message",
      accessorKey: "message",
      id: "message",
      size: 220,
      minSize: 180,
      maxSize: 320,
      enableColumnFilter: !1
    },
    {
      header: "",
      accessorKey: "id",
      id: "actions",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 180,
      minSize: 180,
      maxSize: 180,
      cell: (n) => {
        const a = n.row.original;
        return /* @__PURE__ */ s.jsx(_, { textAlign: "right", children: /* @__PURE__ */ s.jsx(
          Ee,
          {
            type: "INCOMING",
            typeEntity: a.typeEntity,
            name: a.subject.name,
            id: n.renderValue(),
            accept: e,
            dismiss: t,
            textAccept: "Accept",
            textDismiss: "Reject"
          }
        ) });
      },
      meta: {
        align: "right",
        columnType: "action",
        skeletonAlign: "right"
      }
    }
  ]
}, yn = (e) => {
  var n;
  let t = "Oops! Something went wrong";
  return ((n = e == null ? void 0 : e.response) == null ? void 0 : n.status) === 500 && (t = e == null ? void 0 : e.message), t;
}, En = ({ setSummary: e }) => {
  const { enqueueSnackbar: t } = ne(), n = $(), a = Je(), { path: i } = k(
    q
  ), {
    list: o,
    status: l,
    error: f,
    notifyMessage: d,
    acceptInvitation: u,
    dismissInvitation: p
  } = ye(B.INCOMING);
  F(() => {
    a(Ve(ze.entityBreadcrumb(i)));
  }, [i]);
  const g = te(() => ze.createCols(u, p), []);
  return F(() => {
    l === b.ERROR && t({
      message: yn(f),
      variant: "error"
    }), (l === D.ACCEPT_SUCCESS || l === D.DISMISS_SUCCESS) && (Ce().then((S) => e(S)), t({
      message: d,
      variant: "success"
    }));
  }, [l, f]), /* @__PURE__ */ s.jsx(
    _,
    {
      container: !0,
      px: 6,
      py: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ s.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
        qe,
        {
          showFilterToggle: !0,
          filtersDefaultClosed: !0,
          enableFiltering: !0,
          pinnedColumns: { right: ["actions"] },
          columns: g,
          data: o,
          loadingMessage: "Loading...",
          loading: l === b.IN_PROGRESS || l === b.INITIAL,
          noDataText: "No data currently available",
          onRowClick: (S) => {
            const c = tt(
              S.original,
              "INCOMING"
            );
            c && n(c);
          },
          defaultSorting: { id: "created.timestamp", desc: !0 }
        }
      ) })
    }
  );
}, Le = (e) => {
  var t;
  return ((t = Ke.find((n) => n.value === e)) == null ? void 0 : t.name) || e || "-";
}, xn = (e) => {
  var t;
  return ((t = O[e]) == null ? void 0 : t.name) || "-";
}, In = (e, t, n) => {
  var i, o;
  const a = (i = n == null ? void 0 : n[0]) == null ? void 0 : i.toLowerCase();
  return a ? [(o = e.original.subject) == null ? void 0 : o.name, e.original.message].some(
    (l) => String(l || "").toLowerCase().includes(a)
  ) : !0;
}, Me = {
  entityBreadcrumb: (e) => [
    {
      name: "Artifacts library",
      path: `${e}`
    },
    {
      name: "My submissions",
      path: `${e}/outgoing`
    }
  ],
  createCols: (e) => [
    {
      header: "Search",
      id: "search",
      accessorFn: (t) => {
        var n;
        return `${((n = t.subject) == null ? void 0 : n.name) || ""} ${t.message || ""}`;
      },
      filterFn: In,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      size: 0,
      minSize: 0,
      maxSize: 0,
      meta: {
        filterVariant: "value",
        invisible: !0
      }
    },
    {
      header: "",
      accessorFn: (t) => {
        var n;
        return (n = O[t.typeEntity]) == null ? void 0 : n.iconName;
      },
      id: "typeEntityIcon",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 48,
      minSize: 48,
      maxSize: 48,
      cell: (t) => /* @__PURE__ */ s.jsx(
        Se,
        {
          ...t,
          value: t.renderValue(),
          size: 26,
          cell: !0
        }
      ),
      meta: {
        columnType: "action",
        skeletonKind: "type-icon"
      }
    },
    {
      header: "Name",
      accessorKey: "subject.name",
      id: "subject.name",
      size: 420,
      minSize: 320,
      maxSize: 1200,
      enableColumnFilter: !1,
      cell: he
    },
    {
      header: "Type",
      accessorFn: (t) => xn(t.typeEntity),
      id: "type",
      size: 140,
      minSize: 140,
      maxSize: 140,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 1
      }
    },
    {
      header: "Created",
      accessorKey: "created.timestamp",
      id: "created.timestamp",
      size: 152,
      minSize: 152,
      maxSize: 152,
      enableColumnFilter: !1,
      enableResizing: !1,
      cell: Ge
    },
    {
      header: "Created",
      accessorFn: (t) => {
        var n;
        return Qe((n = t.created) == null ? void 0 : n.timestamp);
      },
      id: "created.filter",
      size: 0,
      minSize: 0,
      maxSize: 0,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 2,
        invisible: !0,
        renderFilter: et
      }
    },
    {
      header: "Request Message",
      accessorKey: "message",
      id: "message",
      size: 260,
      minSize: 220,
      maxSize: 420,
      enableColumnFilter: !1
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      cell: ({ renderValue: t }) => {
        const n = Ye(), a = t();
        return /* @__PURE__ */ s.jsx(
          Be,
          {
            light: !0,
            text: Le(a),
            color: He(a, n),
            align: "center"
          }
        );
      },
      size: 120,
      minSize: 120,
      maxSize: 120,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 0,
        renderFilter: Le
      }
    },
    {
      header: "",
      accessorKey: "id",
      id: "actions",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 120,
      minSize: 120,
      maxSize: 120,
      cell: (t) => {
        const n = t.row.original;
        return /* @__PURE__ */ s.jsx(_, { textAlign: "right", children: n.status === We.PENDING ? /* @__PURE__ */ s.jsx(
          Ee,
          {
            type: "OUTGOING",
            typeEntity: n.typeEntity,
            name: t.row.original.subject.name,
            id: t.renderValue(),
            dismiss: e,
            textDismiss: "Cancel"
          }
        ) : /* @__PURE__ */ s.jsx(s.Fragment, {}) });
      },
      meta: {
        align: "right",
        columnType: "action",
        skeletonAlign: "right"
      }
    }
  ]
}, Tn = ({ setSummary: e }) => {
  const { enqueueSnackbar: t } = ne(), n = Je(), a = $(), { path: i } = k(
    q
  ), { list: o, status: l, dismissInvitation: f, error: d, notifyMessage: u } = ye(B.OUTGOING);
  F(() => {
    n(Ve(Me.entityBreadcrumb(i)));
  }, [i]);
  const p = te(() => Me.createCols(f), []);
  return F(() => {
    l === b.ERROR && t({
      message: wt(d),
      variant: "error"
    }), (l === D.ACCEPT_SUCCESS || l === D.DISMISS_SUCCESS) && (Ce().then((g) => e(g)), t({
      message: u,
      variant: "success"
    }));
  }, [l, d]), /* @__PURE__ */ s.jsx(
    _,
    {
      container: !0,
      px: 6,
      py: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ s.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
        qe,
        {
          showFilterToggle: !0,
          filtersDefaultClosed: !0,
          enableFiltering: !0,
          pinnedColumns: { right: ["actions"] },
          columns: p,
          data: o,
          loadingMessage: "Loading...",
          loading: l === b.IN_PROGRESS || l === b.INITIAL,
          noDataText: "No data currently available",
          onRowClick: (g) => {
            const S = tt(
              g.original,
              "OUTGOING"
            );
            S && a(S);
          },
          defaultSorting: { id: "created.timestamp", desc: !0 }
        }
      ) })
    }
  );
}, Rn = (e) => {
  const { children: t, tabs: n } = e, { subModules: a } = k(
    q
  ), i = te(() => a == null ? void 0 : a.customCode, [a == null ? void 0 : a.customCode]);
  return /* @__PURE__ */ s.jsxs(ht, { children: [
    /* @__PURE__ */ s.jsxs(bt, { children: [
      /* @__PURE__ */ s.jsx(
        Ct,
        {
          title: "Artifacts library",
          iconName: "library",
          customButtons: /* @__PURE__ */ s.jsx(
            i,
            {
              type: "component",
              name: "publish-custom-code",
              subModules: a,
              config: {}
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(yt, { tabs: n, withRouting: !0 })
    ] }),
    /* @__PURE__ */ s.jsx(Et, { children: t })
  ] });
}, ke = "prometheus:custom-features-changed", jn = () => {
  let e = it();
  const t = $(), { subModules: n, path: a, initStorage: i, storage: o, rootSettings: l } = k(
    q
  ), [f, d] = w(), [u, p] = w(), [g, S] = w(!1), { entityNavigationPanel: c } = mn, E = De.useCallback(() => {
    Oe().then((x) => {
      p(x), S(!0);
    }).catch((x) => {
      var v;
      p(0), [401, 403].includes((v = x == null ? void 0 : x.response) == null ? void 0 : v.status) && S(!1);
    });
  }, []);
  F(() => {
    let x = !0;
    return Ce().then((v) => {
      x && d(v);
    }), Oe().then((v) => {
      x && (p(v), S(!0));
    }).catch((v) => {
      var L;
      x && (p(0), [401, 403].includes((L = v == null ? void 0 : v.response) == null ? void 0 : L.status) && (S(!1), (e.pathname === "/library/incoming" || e.pathname.startsWith("/library/custom-features")) && t("/library", { replace: !0 })));
    }), () => {
      x = !1;
    };
  }, [e.pathname, t]), F(() => (window.addEventListener(
    ke,
    E
  ), () => {
    window.removeEventListener(
      ke,
      E
    );
  }), [E]);
  const I = te(() => c(
    g,
    f,
    u,
    g
  ), [u, g, f]);
  return /* @__PURE__ */ s.jsx(Rn, { tabs: I, children: /* @__PURE__ */ s.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsxs($e, { children: [
    /* @__PURE__ */ s.jsx(N, { index: !0, element: /* @__PURE__ */ s.jsx(gn, {}) }),
    g && /* @__PURE__ */ s.jsx(
      N,
      {
        path: "incoming",
        element: /* @__PURE__ */ s.jsx(En, { setSummary: d })
      }
    ),
    /* @__PURE__ */ s.jsx(
      N,
      {
        path: "outgoing",
        element: /* @__PURE__ */ s.jsx(Tn, { setSummary: d })
      }
    ),
    g && /* @__PURE__ */ s.jsx(
      N,
      {
        path: "custom-features/*",
        element: /* @__PURE__ */ s.jsx(
          n.featureanalyses,
          {
            name: "custom-features",
            iconName: "feature-analyses",
            path: `${a}/custom-features`,
            title: "Custom Features",
            subModules: n,
            initStorage: i,
            storage: o,
            rootSettings: l,
            isMainMenu: !1,
            config: {
              typeContainer: Y.LIBRARY,
              parentId: null,
              featureEntitySource: "draft"
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      N,
      {
        path: "feature-analyses/*",
        element: /* @__PURE__ */ s.jsx(
          n.featureanalyses,
          {
            name: "feature-analyses",
            iconName: "feature-analyses",
            path: `${a}/feature-analyses`,
            title: "Feature analyses",
            subModules: n,
            initStorage: i,
            storage: o,
            rootSettings: l,
            isMainMenu: !1,
            config: {
              typeContainer: Y.LIBRARY,
              parentId: null,
              featureEntitySource: "published"
            }
          }
        )
      }
    )
  ] }) }) });
}, q = rt(null), _n = (e) => {
  const {
    path: t,
    title: n,
    name: a,
    storage: i,
    initStorage: o,
    rootSettings: l,
    subModules: f,
    config: d
  } = e, [u, p] = w(l), [g, S] = w(!0);
  return F(() => {
    l || p({
      rootPath: t,
      rootTitle: n
    }), S(!1), document.title = "Prometheus - Library";
  }, []), g ? /* @__PURE__ */ s.jsx(Ue, { children: /* @__PURE__ */ s.jsx(be, { size: 32 }) }) : /* @__PURE__ */ s.jsx(q.Provider, { value: { ...e, rootSettings: u }, children: /* @__PURE__ */ s.jsxs($e, { children: [
    /* @__PURE__ */ s.jsx(
      N,
      {
        path: "cohorts/*",
        element: /* @__PURE__ */ s.jsx(
          f.cohort,
          {
            name: "cohorts",
            iconName: "cohorts",
            path: `${t}/cohorts`,
            title: "Cohorts",
            subModules: f,
            initStorage: o,
            storage: i,
            rootSettings: u,
            isMainMenu: !1,
            config: {
              typeContainer: Y.LIBRARY,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      N,
      {
        path: "concept-sets/*",
        element: /* @__PURE__ */ s.jsx(
          f.concept,
          {
            name: "concept-sets",
            iconName: "concept-sets",
            path: `${t}/concept-sets`,
            title: "Concept sets",
            subModules: f,
            initStorage: o,
            storage: i,
            rootSettings: u,
            isMainMenu: !1,
            config: {
              typeContainer: Y.LIBRARY,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      N,
      {
        path: "custom-code/*",
        element: /* @__PURE__ */ s.jsx(
          f.customCode,
          {
            name: "custom-code",
            iconName: "feature-analyses",
            path: `${t}/custom-code`,
            title: "Custom code",
            subModules: f,
            initStorage: o,
            storage: i,
            rootSettings: u,
            isMainMenu: !1,
            config: {
              typeContainer: Y.LIBRARY,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      N,
      {
        path: "custom-features/publish-requests/*",
        element: /* @__PURE__ */ s.jsx(
          f.featureanalyses,
          {
            name: "custom-features-publish-request",
            iconName: "feature-analyses",
            path: `${t}/custom-features/publish-requests`,
            title: "Custom Features",
            subModules: f,
            initStorage: o,
            storage: i,
            rootSettings: u,
            isMainMenu: !1,
            config: {
              typeContainer: Y.LIBRARY,
              parentId: null,
              featureEntitySource: "draft",
              publishRequestPreview: !0
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(N, { path: "/*", element: /* @__PURE__ */ s.jsx(jn, {}) })
  ] }) });
}, kn = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !t && /* @__PURE__ */ s.jsx(_n, { ...e }),
    t === "component" && /* @__PURE__ */ s.jsx(dn, { ...e })
  ] });
};
export {
  kn as Library
};
//# sourceMappingURL=library.js.map
